export default __webpack_public_path__ + "static/media/dress12.d6b15c44.jpeg";